const APP_VERSION = 'v8.7.1';

export default APP_VERSION;
